import { type FC } from 'react';
import { Button } from '../../../web/components-v2/Button';
import { IconMic } from './icons';

type SparButtonProps = {
	/** Invoked when the rep clicks to start an ad-hoc AI roleplay against this contact. */
	onClick: () => void;
	/** Disables the button (e.g. while a Spar session is already connecting). */
	disabled?: boolean;
};

/**
 * Per-contact "Practice with AI" affordance shown in a contact row's actions
 * area. Starts an ad-hoc AI voice-roleplay ("Spar") session against a REAL
 * lead's persona without entering Practice Mode. Coffee-gated by the caller
 * (`LeftColumn` only renders it when `enableSpar` is true).
 *
 * Intentionally dumb: it owns no session state and simply forwards the click.
 * Mirrors the row's other icon affordances by using the components-v2 ghost
 * icon Button with the mic icon already used by the Practice Mode toolbar.
 */
export const SparButton: FC<SparButtonProps> = ({ onClick, disabled }) => (
	<Button
		variant='ghost'
		size='icon'
		title='Practice with AI'
		aria-label='Practice with AI'
		onClick={onClick}
		disabled={disabled}
	>
		<IconMic size={14} />
	</Button>
);
